import moment from 'moment-timezone';

export default function validTimeDiff(
  timestamp: number | undefined,
  minDiff: number
) {
  if (!timestamp) return true;
  return moment(timestamp).diff(moment(), 'minutes') > minDiff;
}
